import { DEFAULT_CURRENCY_CODE, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { browserTracingIntegration } from '@sentry/angular';

import { AppModule } from '@app/app.module';
import { PuSubscribe } from '@app/utils/pu-subscribe';
import './app/modules/shared/utils/storage-quota.guard';

import { environment } from './environments/environment';
import { EnvironmentType } from './environments/environment-config';

if (window.location.hostname !== 'localhost') {
  const apiOrigin = new URL(environment.apiUrl).origin;

  Sentry.init({
    dsn: environment.sentryUrl,
    integrations: [browserTracingIntegration()],
    tracePropagationTargets: [apiOrigin, /^\//],
    tracesSampleRate: 1.0,
    environment: EnvironmentType[environment.type].toLowerCase(),
  });
}

if (environment.type === EnvironmentType.Prod) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    providers: [
      { provide: DEFAULT_CURRENCY_CODE, useValue: 'USD' },
      {
        provide: PuSubscribe,
        useValue: new PuSubscribe(),
      },
    ],
  })
  .catch(err => console.error(err));
